import { Link, useLocation } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";

// Ordered most -> least priority (appointments & calls first)
const links = [
  { to: "/calendar", label: "Availability" },
  { to: "/request-service", label: "Request Service" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/partners", label: "Partners" },
  { to: "/grant-appreciation", label: "Appreciation" },
];

export function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed w-full z-50 backdrop-blur-xl bg-white/85 border-b border-[#E5DEEB]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src={LOGO_URL} alt="Utopia Dental Care" className="h-12 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          <Link
            to="/book"
            data-testid="nav-book"
            className="bg-[#6B4C8A] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#543C6E] transition-colors shadow-sm"
          >
            Book Appointment
          </Link>
          <a
            href="tel:5053633435"
            data-testid="nav-call"
            className="flex items-center gap-2 border border-[#6B4C8A] text-[#6B4C8A] px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#F3EFF7] transition-colors"
          >
            <Phone className="h-4 w-4" /> 505-363-3435
          </a>
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-medium transition-colors hover:text-[#6B4C8A] ${
                pathname === l.to ? "text-[#6B4C8A]" : "text-[#5C5166]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/admin" data-testid="nav-admin" className="text-sm font-medium text-[#A69CAF] hover:text-[#6B4C8A] transition-colors">
            Admin
          </Link>
        </nav>

        <button
          className="lg:hidden text-[#2D2336]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#E5DEEB] px-6 py-4 flex flex-col gap-4">
          <Link to="/book" onClick={() => setOpen(false)} className="bg-[#6B4C8A] text-white px-5 py-2.5 rounded-full text-sm font-semibold text-center">Book Appointment</Link>
          <a href="tel:5053633435" onClick={() => setOpen(false)} className="flex items-center justify-center gap-2 border border-[#6B4C8A] text-[#6B4C8A] px-5 py-2.5 rounded-full text-sm font-semibold">
            <Phone className="h-4 w-4" /> 505-363-3435
          </a>
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-[#5C5166] font-medium">
              {l.label}
            </Link>
          ))}
          <Link to="/admin" onClick={() => setOpen(false)} className="text-[#A69CAF] font-medium">Admin Portal</Link>
        </div>
      )}
    </header>
  );
}
